var _defs, _circle, _g, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Person_Icon",
    "data-name": "Person Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.44,
    height: 72.434,
    viewBox: "0 0 72.44 72.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #ea0308;\n      }\n\n      .cls-1 {\n        stroke-width: 3.79px;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n        stroke-width: 3px;\n        fill-rule: evenodd;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    className: "cls-1",
    cx: 36.345,
    cy: 21.499,
    r: 11.405
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1826.36,1034c0.82-21.4,34.83-22.35,35.81,0",
    transform: "translate(-1807.81 -979.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1825.83,1034h36.8",
    transform: "translate(-1807.81 -979.656)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Outline",
    className: "cls-1",
    cx: 36.22,
    cy: 36.22,
    r: 34.31
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.3bfdc13d4948e417b46277630981f1a7.svg";
export { ForwardRef as ReactComponent };